import { render, staticRenderFns } from "./SectorManageList.vue?vue&type=template&id=627eb530"
import script from "./SectorManageList.vue?vue&type=script&lang=js"
export * from "./SectorManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports